// AdminLogin.tsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { accessOffers } from "../../api/api-hook";
import { loadOffersSession, saveOffersSession } from "./offersSession";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Already logged in on this device: go straight to the offers
  useEffect(() => {
    if (loadOffersSession()) navigate("/offers", { replace: true });
  }, [navigate]);
  const [lastName, setlastName] = useState("");
  const [memberNumber, setMemberNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setLoading(true);
  setMessage(null);
  setError(null);

  try {
    // Step 1: request OTP (NO code yet)
    const response_data: any = await accessOffers(lastName, memberNumber || undefined);

    // Your api-hook returns a string sometimes
    const data = typeof response_data === "string" ? JSON.parse(response_data) : response_data;

    console.log(data);

    if (data?.status === "code_sent") {
      // ✅ Move to verify screen
      navigate("/offers/verify", {
        replace: true,
        state: {
          lastName,
          memberNumber,
          contactId: data.contactId ?? null, // include if your backend returns it
          // The code emailed earlier is still valid, so nothing was sent this time
          codeReused: !!data.reused,
          emailed: data.emailed !== false,
          sentAt: data.sentAt ?? null,
          expiresAt: data.expiresAt ?? null,
        },
      });
      return;
    }

    // If your backend ever returns authenticated here, handle it too
    if (data?.status === "authenticated") {
      saveOffersSession(data.contactId);
      navigate("/offers", {
        replace: true,
        state: { contactId: data.contactId },
      });
      return;
    }

    setError(data?.message || "Not authorized. Please check your details and try again.");
  } catch (err) {
    console.error(err);
    setError("Network error. Please try again.");
  } finally {
    setLoading(false);
  }
};


  return (
    <section className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <h2 className="mb-3 text-center text-uppercase" style={{ fontSize: "1rem", letterSpacing: "0.08em" }}>
                VSGA GOLF CARD PORTAL
              </h2>
              <p className="text-muted text-center mb-4">
                Enter your Last Name and VIP CARD NUMBER/GHIN NUMBER to receive a 6-digit admin access code. Once you have the code,
                enter it below to log in. Codes are valid for 24 hours.
              </p>

              <form onSubmit={handleSubmit} className="row gy-3">
                {/* Last Name */}
                <div className="col-12">
                  <label htmlFor="LastName" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    className="form-control"
                    value={lastName}
                    onChange={(e) => setlastName(e.target.value)}
                    required
                  />
                </div>

                {/* member nubmer */}
                <div className="col-12">
                  <label htmlFor="code" className="form-label">
                    VIP Card Number/GHIN Number 
                  </label>
                  <input
                    type="text"
                    id="memberNumber"
                    className="form-control"
                    value={memberNumber}
                    onChange={(e) => setMemberNumber(e.target.value.replace(/\D/g, ""))}
                    placeholder=""
                    required
                  />
                </div>

                {/* Button */}
                <div className="col-12 d-grid mt-3">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading
                      ? "Please wait..."
                      : memberNumber
                      ? "Login with Code"
                      : "Send Access Code"}
                  </button>
                </div>
              </form>

              {/* Messages */}
              {message && (
                <div className="alert alert-success mt-3 text-center">
                  {message}
                </div>
              )}

              {error && (
                <div className="alert alert-danger mt-3 text-center">
                  {error}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
